/** @typedef {import('../index.js').InvalidDocData} InvalidDocData */
/** @typedef {import('./user.js').UserDocData} UserDocData */
import Admin from './admin.js';
import User from './user.js';
import { isParallelStaffEmail } from '../../utils/index.js';

/**
 * Converts a Firestore document snapshot into a {@link User} or subclass instance.
 * @param {any} doc Raw Firestore document snapshot.
 * @returns A {@link User} or subclass instance.
 */
function userFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    if (isParallelStaffEmail(docData.email)) {
      return Admin.fromFirestore(docData);
    }
    return User.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming user data:', docData.id, error);
    /** @type {InvalidDocData} */
    const InvalidDocData = { validation: 'failed', ...docData };
    return InvalidDocData;
  }
}

/**
 * Converts a {@link User} instance into a Firestore-compatible object.
 * @param {User} user A {@link User} instance.
 * @returns A {@link UserDocData} object (without `id`).
 */
function userToFirestore(user, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  if (isParallelStaffEmail(user.email)) {
    return new Admin(user).toFirestore({ serverTimestamp });
  }
  return new User(user).toFirestore({ serverTimestamp });
}

export {
  userFromFirestore,
  userToFirestore,
};
